import { Children, type ReactNode } from 'react';

import { isSlot } from '../../../../../core/utils/is-slot.js';
import {
  EmptyStateSlot,
  type EmptyStateSlotProps,
} from '../../../slots/chart-states/EmptyStateSlot.js';
import {
  ErrorStateSlot,
  type ErrorStateSlotProps,
} from '../../../slots/chart-states/ErrorStateSlot.js';

export function getChartStatesTemplates(children: ReactNode) {
  let emptyState: EmptyStateSlotProps['children'] | undefined,
    errorState: ErrorStateSlotProps['children'] | undefined;

  Children.forEach(children, (child) => {
    if (isSlot(child, EmptyStateSlot)) {
      emptyState = child.props.children;
    } else if (isSlot(child, ErrorStateSlot)) {
      errorState = child.props.children;
    }
  });

  return { emptyState, errorState };
}
